<template>
  <SummaryRow
    v-if="isShowServicePricesEnabled"
    :class="{'estimate--item-emphasis': emphasis}"
    :label="name"
    :sub-label="quantityLabel"
    :value="currency(price)" />
  <SummaryRow
    v-else
    :class="{'estimate--item-emphasis': emphasis}"
    :label="name"
    :sub-label="quantityLabel" />
</template>

<script>
import { Mixins } from '@homegauge/vue';

import SummaryRow from '@/components/common/SummaryRow.vue';
import FeatureFlagUtil from '@/utilities/feature-flag-util';

const { CurrencyFilter } = Mixins;

export default {
  components: {
    SummaryRow,
  },
  mixins: [CurrencyFilter],
  props: {
    emphasis: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    quantityLabel() {
      return this.quantity && this.quantity > 1
        ? `Qty ${this.quantity}`
        : '';
    },
  },
  data() {
    return {
      isShowServicePricesEnabled: FeatureFlagUtil.isShowServicePricesEnabled(),
    };
  },
};
</script>

<style lang="scss" scoped>
.estimate--item {
  &-emphasis {
    font-size: 1.285rem;
  }
}
</style>
